/* template */
<template><mpx-view :class="({    show: show  })" @tap="onClick" class="user-change"><span class="phone">{{ phone }}</span><mpx-image src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAHhlWElmTU0AKgAAAAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAAAAAACQAAAAAQAAAJAAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAABCgAwAEAAAAAQAAABAAAAAA5tjJUwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAOxJREFUOBFjYEAC////FwbidUDshiSMl8kEk4VqugDkmwLxV5g4QRqokQOIO4D4DxCDbBcmqAlJASNQwxkg3wAqBnIBMeA8UNFERkbGKyxAxmwgViRGF5IaFyD7AtBye0YkQZKYIO8CNciRpAlZMdCAOCD+zAQkzgAx0dGGZMgPIJsTFI2gABRAkiCWeQ2osIcB5AwgTidWF4Y6oGZQ3IO8QVL8wwwCpQNZIOcYEIO8cRMmQST9CByNQEM4gBrCgFiLCI0glyZC1fUQoR6hBGiRNRA/hmLSYg6oKR2IycovYCcANeuADEG4B8ICAHqKgD/tGpAvAAAAAElFTkSuQmCC" class="icon"/></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2222576c"}'>
.user-change
  position absolute
  top 0
  left 0
  width 200rpx
  height 61rpx
  background-color #E61209
  border-radius 0 32rpx 32rpx 0
  display flex
  flex-flow row nowrap
  justify-content center
  align-items center
  opacity 0
  transition opacity 200ms ease-in-out
  &.show
    opacity 1
.phone
  font-size 20rpx
  color #FFFFFF
.icon
  width 16rpx
  height 16rpx
  margin-left 8rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createComponent } from '@mpxjs/core'
import { GlobalEnv } from '../../lib/webx'
import { request } from '../../lib/webx/api'
import { GlobalConfig } from '../../lib/webx/config'
import { initEnv, login } from '../../lib/webx/global_env'
import { logout } from '@didi/webx-js'
import { getErrorMessage } from '../../lib/webx/utils/error'
import { MASErrorTrackGetUserInfoError, MASErrorTrackSwitchUserError } from '../../lib/webx/mas_error_track'

createComponent({
  name: 'UserChange',
  async attached() {
    await initEnv({ needLocation: true })
    await this.getUserInfo()
  },
  data: {
    show: false,
    phone: '',
  },
  methods: {
    async getUserInfo() {
      try {
        const params = {
          source_id: GlobalEnv.channelId,
          token: GlobalEnv.loginInfo.token,
        }
        const { info: { cell } } = await request.get(GlobalConfig.APIs.userInfo, params)
        this.phone = cell
        this.show = true
      } catch (error) {
        const msg = getErrorMessage(error, {
          friendly: false,
        })
        MASErrorTrackGetUserInfoError(msg, error)
      }
    },
    async onClick() {
      if (!this.show) return
      try {
        await logout()
        await login()
        await this.getUserInfo()
        // TODO: 后续可以优化一下
        mpx.navigateTo({
          url: 'index',
          success: () => setTimeout(() => window.location.reload(), 100),
        })
      } catch (error) {
        if (error.errno === 100) {
          mpx.navigateTo({
            url: 'index',
            success: () => setTimeout(() => window.location.reload(), 100),
          })
          return
        }
        mpx.showModal({
          content: getErrorMessage(error),
          title: '错误',
        })
        const msg = getErrorMessage(error, {
          friendly: false,
        })
        MASErrorTrackSwitchUserError(msg, error)
      }
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "user_change2222576c",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
